<template>
    <div
        tabindex="0"
        class="base-select"
        :class="isOpen ? 'open' : ''"
        @blur.capture="focusChangeHandler"
        @focus.capture="focusChangeHandler"
    >
        <div class="base-select-input" @click="isOpen = true">
            <span class="base-select-input-name">
                {{ baseSelectInput }}
            </span>
            <i
                class="base-select-icon"
                :class="isOpen ? 'icon-chevron-up' : 'icon-chevron-down'"
            ></i>
            <!-- <img :src="isOpen ? arrowUp : arrowDown" /> -->
        </div>
        <div v-show="isOpen" class="base-select-dropdown">
            <div v-if="searchable" class="base-select-search">
                <input
                    id="base-select-search"
                    type="text"
                    autocomplete="off"
                    placeholder="Search in options"
                    @input="searchOptionsHandler"
                />
            </div>
            <div v-if="options.length > 0" class="base-select-dropdown-inner">
                <div
                    v-for="item in options"
                    :key="item[keyName]"
                    class="base-select-dropdown-item"
                    :class="
                        selectedOption && item[keyName] === selectedOption[keyName] ? 'active' : ''
                    "
                    @click="selectOptionHandler(item)"
                >
                    <slot v-if="hasCustomItem" name="item" :item="item" />
                    <div v-else class="base-select-dropdown-item-inner">
                        {{ item[name] }}
                    </div>
                </div>
            </div>
            <div v-else class="base-select-not-found">
                <h5>Result Not Found!</h5>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        keyName: {
            type: String,
        },
        name: {
            type: String,
        },
        items: {
            type: Array,
        },
        option: {
            type: Object,
        },
        placeholder: {
            type: String,
        },
        searchable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: false,
            options: this.items,
            selectedOption: this.option,
        };
    },
    computed: {
        arrowDown() {
            return require('@/modules/create-ticket/assets/down-arrow-icon-grey.svg');
        },
        arrowUp() {
            return require('@/modules/create-ticket/assets/top-arrow-icon.svg');
        },
        hasCustomItem() {
            return !!this.$slots.item;
        },
        _placeholder() {
            return this.placeholder ?? 'Select an option';
        },
        _value() {
            return this.selectedOption ? this.selectedOption[this.name] : undefined;
        },
        baseSelectInput() {
            return this._value ?? this._placeholder;
        },
    },
    methods: {
        selectOptionHandler(option) {
            this.isOpen = false;
            this.selectedOption = option;
            this.$emit('update:option', option);
            this.$emit('updateValue', option);
        },
        searchOptionsHandler(e) {
            const regex = new RegExp(e.target.value, 'gi');
            this.options = this.items.filter((option) => {
                if (option[this.name].search(regex) > -1) {
                    return option;
                }
            });
        },
        focusChangeHandler(e) {
            if (e.type == 'focus' && e.relatedTarget === null) {
                this.isOpen = true;
            }
            if (e.type == 'blur') {
                setTimeout(() => {
                    if (e.relatedTarget !== null) {
                        if (e.relatedTarget.id !== 'base-select-search') {
                            this.isOpen = false;
                        }
                    } else {
                        this.isOpen = false;
                    }
                }, 200);
            }
        },
    },
};
</script>

<style lang="scss">
.base-select {
    position: relative;
    &-icon {
        font-size: 10px;
        color: #43434a;
    }
    &-input {
        font-size: 14px;
        padding: 13px;
        max-width: 100%;
        max-height: 50px;
        background: rgba(240, 240, 240, 0.8);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        &:hover {
            cursor: pointer;
        }
    }
    &-dropdown {
        top: 50px;
        left: 0px;
        width: 100%;
        z-index: 1000;
        position: absolute;
        border-top: 1px solid #ddd;
        box-shadow: 0 4px 13px rgb(0 0 0 / 15%);
        background-color: rgba(240, 240, 240, 0.8);
        &-inner {
            width: 98%;
            height: 200px;
            margin: 10px 0px;
            overflow-y: auto;
            overflow-x: hidden;
            &::-webkit-scrollbar {
                width: 4px;
            }
            &::-webkit-scrollbar-track {
                border-radius: 4px;
                background: transparent;
                box-shadow: inset 0 0 5px #ccc;
                border-left: 1.5px solid transparent;
                border-right: 1.5px solid transparent;
            }
            &::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 4px;
            }
            &::-webkit-scrollbar-thumb:hover {
                cursor: pointer;
                background: #666;
            }
        }
        &-item {
            width: 100%;
            padding: 16px;
            font-size: 14px;
            &.active {
                color: #000;
                font-weight: bold;
                background: #fff;
            }
            &:hover {
                cursor: pointer;
            }
        }
    }
    &-search {
        width: 100%;
        padding: 10px 10px 0px 10px;
        & input {
            width: 100%;
            border: 0px;
            outline: none;
            border-radius: 6px;
            padding: 10px !important;
        }
    }
    &-not-found {
        height: 100px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    &.open {
        & .base-select-input {
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            border-bottom-left-radius: 0px;
            border-bottom-right-radius: 0px;
        }
        & .base-select-dropdown {
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
        }
    }
}
</style>
